// https://github.com/TinderBackend/revive.trust/blob/main/service/caseservice/service/src/main/java/com/tinder/caseservice/utils/CaseServiceHelper.java#L20

export const MATCH_ID_PATTERN = '[0-9a-fA-F]{48}';
export const USER_ID_PATTERN = '[0-9a-fA-F]{24}';
export const UUID_PATTERN = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';

export const MATCH_ID_REGEX = new RegExp(MATCH_ID_PATTERN);
export const USER_ID_REGEX = new RegExp(USER_ID_PATTERN);
export const UUID_REGEX = new RegExp(UUID_PATTERN);
